import { render, staticRenderFns } from "./FilterCriteriaChoice.vue?vue&type=template&id=ace85ece&scoped=true&"
import script from "./FilterCriteriaChoice.vue?vue&type=script&lang=js&"
export * from "./FilterCriteriaChoice.vue?vue&type=script&lang=js&"
import style0 from "./FilterCriteriaChoice.vue?vue&type=style&index=0&id=ace85ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace85ece",
  null
  
)

/* custom blocks */
import block0 from "./FilterCriteriaChoice.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ace85ece')) {
      api.createRecord('ace85ece', component.options)
    } else {
      api.reload('ace85ece', component.options)
    }
    module.hot.accept("./FilterCriteriaChoice.vue?vue&type=template&id=ace85ece&scoped=true&", function () {
      api.rerender('ace85ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/comparison/filter-criteria/FilterCriteriaChoice.vue"
export default component.exports